import React, {useEffect} from "react";
import { ReactTyped } from "react-typed";
import "./intro.css";
import { useTranslation } from "react-i18next";
import video from "../img/video-bg/Alpha_3.webm";

const Intro = () => {
  const { t, i18n } = useTranslation();
  
    const changeLanguage = (lng) => {
      i18n.changeLanguage(lng);
      localStorage.setItem("lng", lng);
    };
  
    useEffect(() => {
      changeLanguage(localStorage.getItem("lng") || "en");
    }, []);

  return (
    <section
      id="home"
      className=" bg-gradient-to-r from-primary/100 to-primaryDark/70 flex flex-col md:flex-row items-center justify-between  bg-white  "
    >
      <div className="flex flex-col sm:flex-row items-center justify-center sm:items-center sm:justify-between mx-auto w-full sm:h-[80vh] h-[55vh] max-w-screen-xl  ">

      {/* Блок текста */}
      <div className=" w-full justify-center items-center flex ">
        <ReactTyped
          className=" sm:text-7xl text-4xl  font-bold text-gray-800 text-center md:text-left "
          strings={[t("intro_header")]}
          typeSpeed={70}
          startDelay={1000}
          showCursor={false}
        />
      </div>

      {/* Видео справа */}
     <div className="w-full  sm:flex justify-center items-center hidden">
      {/* Spline 3D Viewer */}
      <video
    src={video}
    alt="Animation"
    className="w-full  h-full  aboslute right-0 top-0"
    // controls // Добавляет элементы управления (пауза, воспроизведение, громкость)
    autoPlay // Автоматическое воспроизведение
    loop // Зацикливание видео
    muted // Без звука (обязательно для автовоспроизведения в большинстве браузеров)
    playsInline // Для корректного воспроизведения на мобильных устройствах
    preload="auto" // Предзагрузка видео

  />
    </div>
      </div>
    </section>
  );
};

export default Intro;
